import { UserQueueSettings } from '../../interfaces/user-queue-settings';
import { LimitOffsetPaging } from '../paged-results/limit-offset-paging.model';

export class EncounterListSettings {
  filters: null;
  paging: LimitOffsetPaging = LimitOffsetPaging.empty;
}

export class EncounterQueueSettings extends EncounterListSettings implements UserQueueSettings {
  position: number;
}
